var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.64 54.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M0,27.32c0,15.09,12.23,27.32,27.32,27.32s27.32-12.23,27.32-27.32S42.41,0,27.32,0,0,12.23,0,27.32ZM28.58,11.13v29.29l10.72-11.01c.24-.24,.55-.38,.89-.38,.34,0,.66,.12,.9,.36,.25,.24,.38,.56,.38,.9s-.13,.64-.36,.88l-12.92,13.31h-.03l-.06,.03c-.11,.09-.28,.17-.47,.22l-.15,.03c-.18,.02-.34,.02-.5-.03h-.29l-.08-.17c-.07-.05-.14-.1-.2-.17l-12.89-13.23c-.48-.5-.47-1.3,.02-1.78,.5-.49,1.3-.47,1.79,.02l10.72,11.01V11.13c0-.7,.57-1.26,1.26-1.26s1.26,.57,1.26,1.26Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.c122209d7170054c0a17f5d52399614a.svg";
export { ForwardRef as ReactComponent };